module.exports = __webpack_public_path__ + "media/images/icon-country-91b8677e5b3b2e37da50c4428690325f.svg";